// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"4194db4b","194":"7cb03513","488":"371f7511","721":"97037351","734":"be81d63c","803":"87980c6a","950":"ed3899e4"}[chunkId] + ".chunk.js";
};